// src/pages/ForgotPassword.jsx
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  Text,
  useToast,
  Image,
  VStack,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
import { supabase } from '../config/supabaseClient';
import logo from '../assets/logo.png';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  
  const toast = useToast();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast({
        title: 'Email obrigatório',
        description: 'Por favor, insira seu endereço de email.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    
    setLoading(true);
    
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      
      if (error) throw error;
      
      setEmailSent(true);
      
    } catch (error) {
      toast({
        title: 'Erro',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxW="md" py={12}>
      <VStack spacing={6} align="center" mb={8}>
        <Image src={logo} alt="Draw Your Goods" height="60px" />
        
        <Heading size="lg" textAlign="center" color="brand.primary">
          Recuperação de Senha
        </Heading>
        
        <Text fontSize="md" color="gray.600" textAlign="center">
          Informe seu email e enviaremos um link para redefinir sua senha.
        </Text>
      </VStack>
      
      <Box p={8} borderRadius="lg" boxShadow="md" bg="white">
        {emailSent ? (
          <Alert
            status="success"
            variant="subtle"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            borderRadius="md"
            py={4}
          >
            <AlertIcon boxSize="40px" mr={0} />
            <Text mt={4} mb={2} fontSize="lg" fontWeight="bold">
              Email enviado com sucesso!
            </Text>
            <Text fontSize="md">
              Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.
            </Text>
          </Alert>
        ) : (
          <form onSubmit={handleResetPassword}>
            <Stack spacing={4}>
              <FormControl id="email" isRequired>
                <FormLabel>Email</FormLabel>
                <Input 
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Seu email cadastrado"
                />
              </FormControl>
              
              <Button
                type="submit"
                colorScheme="blue"
                bgGradient="linear(to-r, brand.primary, brand.secondary)"
                color="white"
                size="lg"
                width="full"
                mt={4}
                isLoading={loading}
                _hover={{
                  transform: 'translateY(-2px)',
                  boxShadow: 'lg',
                }}
              >
                Enviar link de recuperação
              </Button>
            </Stack>
          </form>
        )}
        
        <Text mt={6} textAlign="center">
          Lembrou da senha?{' '}
          <RouterLink to="/login" style={{ color: '#A5B4E8' }}>
            Voltar para login
          </RouterLink>
        </Text>
      </Box>
    </Container>
  );
};

export default ForgotPassword;